var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInstance = function SvgInstance(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2629 20.344L20.344 14.2629C21.1361 13.4709 21.532 13.0746 21.6803 12.6179C21.8109 12.2162 21.8109 11.7844 21.6803 11.3827C21.532 10.926 21.1361 10.5291 20.344 9.73711L14.2616 3.65465C13.4704 2.86351 13.0748 2.46786 12.6184 2.31957C12.2167 2.18905 11.7839 2.18905 11.3822 2.31957C10.9257 2.46788 10.529 2.86462 9.7376 3.65599L3.65648 9.73711L3.656 9.73802C2.86429 10.5297 2.46791 10.9261 2.31957 11.3827C2.18905 11.7844 2.18905 12.2162 2.31957 12.6179C2.46786 13.0743 2.864 13.4704 3.65514 14.2616L9.74136 20.3478C10.5309 21.1373 10.9262 21.5327 11.3822 21.6808C11.7839 21.8113 12.2167 21.8113 12.6184 21.6808C13.0749 21.5325 13.4706 21.1368 14.2621 20.3453L14.2629 20.344Z",
    stroke: "#282830",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInstance, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Instance.3a357554.svg";
export { ForwardRef as ReactComponent };